import React from 'react';
const comparisonRows = [{
  situation: 'Tu cobro',
  without: 'Por clase, irregular',
  with: 'Abono mensual el día 1-5'
}, {
  situation: 'Cancelaciones',
  without: 'Sin política clara',
  with: 'Reglamento firmado'
}, {
  situation: 'Ingresos',
  without: 'Impredecibles',
  with: 'Fijos desde el día 5'
}, {
  situation: 'Nuevos alumnos',
  without: 'Solo boca a boca',
  with: 'Sistema de referidos activo'
}, {
  situation: 'Clínicas',
  without: 'No las haces',
  with: '1 sábado = lo que ganas en semana'
}, {
  situation: 'Tu Instagram',
  without: 'Sin estrategia',
  with: '30 días de contenido listo'
}, {
  situation: 'El alumno que falta',
  without: 'Sin sistema',
  with: 'Protocolo de re-enganche'
}, {
  situation: 'Tu precio',
  without: 'El del mercado o menos',
  with: '30-50% más justificado'
}];
const blocks = [{
  icon: '💰',
  title: 'Bloque 1 — El Abono Blindado',
  desc: 'Del cobro por clase al abono mensual adelantado. Incluye reglamento + contrato listo.'
}, {
  icon: '🎾',
  title: 'Bloque 2 — Fábrica de Clínicas',
  desc: 'Clínica de 3 hs = 15 hs de clase individual. Estructura + flyer editable en Canva.'
}, {
  icon: '📱',
  title: 'Bloque 3 — WhatsApp que Vende',
  desc: 'Scripts para convertir interesados en alumnos fijos en 3 mensajes + referidos.'
}, {
  icon: '📸',
  title: 'Bloque 4 — Marketing Cero Gasto',
  desc: 'Usa tus clases para crear contenido. 20 tipos de post + calendario de 30 días.'
}];
const assets = ['Planilla de Caja Profe', 'Calculadora de Precio Justo', 'Reglamento de Cancelaciones', 'Contrato Ético', 'Flyer Editable', 'Pack de 20 Stories para Instagram'];
export function EliteSection() {
  return <section className="w-full bg-[#001a2d] py-16 px-4" data-id="element-74">
      <div className="max-w-4xl mx-auto" data-id="element-75">
        <div className="text-center mb-10" data-id="element-76">
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-4" data-id="element-77">
            🎾 ¿QUÉ AGREGA EL{' '}
            <span className="text-[#00B4D8]" data-id="element-78">PÁDEL PRO BUSINESS™</span>?
          </h2>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto" data-id="element-79">
            El sistema de cobro, captación e identidad que hace que tu negocio
            esté a la altura de tus clases.
          </p>
        </div>

        {/* Comparison Table */}
        <div className="bg-black border border-[#00B4D8]/30 rounded-2xl overflow-hidden mb-12" data-id="element-80">
          {/* Header */}
          <div className="grid grid-cols-1 sm:grid-cols-3 bg-[#000d1a] border-b border-[#00B4D8]/30" data-id="element-81">
            <div className="p-4 font-bold text-white hidden sm:block" data-id="element-82">
              Situación
            </div>
            <div className="p-4 font-bold text-gray-400 text-center border-l border-[#00B4D8]/30" data-id="element-83">
              Sin Pádel Pro Business
            </div>
            <div className="p-4 font-bold text-[#00B4D8] text-center border-l border-[#00B4D8]/30" data-id="element-84">
              Con Pádel Pro Business
            </div>
          </div>

          {/* Rows */}
          {comparisonRows.map((row, i) => <div key={row.situation} className={`grid grid-cols-1 sm:grid-cols-3${i < comparisonRows.length - 1 ? ' border-b border-gray-800' : ''}`} data-id="element-85">
              <div className="p-4 text-white text-sm sm:text-base" data-id="element-86">
                <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-87">
                  Situación:
                </span>
                {row.situation}
              </div>
              <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-88">
                <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-89">
                  Sin Pádel Pro Business:
                </span>
                {row.without}
              </div>
              <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#00B4D8]/5" data-id="element-90">
                <span className="sm:hidden font-bold text-[#00B4D8] block mb-1" data-id="element-91">
                  Con Pádel Pro Business:
                </span>
                {row.with}
              </div>
            </div>)}
        </div>

        {/* Features List */}
        <h3 className="text-2xl font-black text-white text-center mb-8" data-id="element-92">
          ✅ PÁDEL PRO BUSINESS™ INCLUYE:
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-93">
          {blocks.map(block => <div key={block.title} className="bg-black border border-[#00B4D8]/20 rounded-xl p-5" data-id="element-94">
              <h4 className="text-[#00B4D8] font-bold text-lg mb-2" data-id="element-95">
                {block.icon} {block.title}
              </h4>
              <p className="text-gray-400 text-sm" data-id="element-96">{block.desc}</p>
            </div>)}

          <div className="bg-black border border-[#00B4D8]/20 rounded-xl p-5 md:col-span-2" data-id="element-97">
            <h4 className="text-[#00B4D8] font-bold text-lg mb-2" data-id="element-98">
              📊 Assets incluidos:
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-99">{assets.join(' · ')}</p>
          </div>
        </div>
      </div>
    </section>;
}